import { QueryKey, queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import { parseAbi } from 'viem'
import { Config, useConfig } from 'wagmi'
import { readContract } from 'wagmi/actions'

export interface SimulationTimestampQueryOptionsParams {
  wagmiConfig: Config
  chainId: number
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function simulationTimestampQueryOptions({ wagmiConfig, chainId }: SimulationTimestampQueryOptionsParams) {
  return queryOptions({
    queryKey: getSimulationTimestampQueryKey({ chainId }),
    queryFn: async () => {
      return await readContract(wagmiConfig, {
        address: '0xcA11bde05977b3631167028862bE2a173976CA11',
        abi: parseAbi(['function getCurrentBlockTimestamp() public view returns (uint256 timestamp)']),
        functionName: 'getCurrentBlockTimestamp',
        chainId,
      })
    },
  })
}

export function getSimulationTimestampQueryKey({ chainId }: { chainId: number }): QueryKey {
  return ['simulation-timestamp', chainId]
}

export interface UseSimulationTimestampResult {
  simulationTimestamp: number
  isFetching: boolean
  refresh: () => void
}

export function useSimulationTimestamp({ chainId }: { chainId: number }): UseSimulationTimestampResult {
  const wagmiConfig = useConfig()

  const {
    data: simulationTimestamp,
    isFetching,
    refetch,
  } = useSuspenseQuery({
    ...simulationTimestampQueryOptions({ wagmiConfig, chainId }),
  })

  return {
    simulationTimestamp: Number(simulationTimestamp) - 1, // 1 second buffer to mitigate potential calculation issues
    isFetching,
    refresh: refetch,
  }
}
